import React from "react";
import { Row, Col } from "@themesberg/react-bootstrap";

export function StatCardSkeleton({ count = 4 }) {
  return (
    <Row className="g-4">
      {Array.from({ length: count }).map((_, index) => (
        <Col key={index} xs={12} sm={6} xl={3}>
          <div className="dashboard-skeleton dashboard-skeleton-card" />
        </Col>
      ))}
    </Row>
  );
}

export function TableSkeleton({ rows = 4 }) {
  return (
    <div className="dashboard-skeleton-table">
      {Array.from({ length: rows }).map((_, index) => (
        <div key={index} className="dashboard-skeleton dashboard-skeleton-row" />
      ))}
    </div>
  );
}

export default function LoadingSkeleton({ variant = "stats", count = 4 }) {
  if (variant === "table") {
    return <TableSkeleton rows={count} />;
  }
  return <StatCardSkeleton count={count} />;
}
